import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../../common/api/request';

interface DeleteTempDatasetParams {
  datasetID: number;
}

interface DeleteTempDatasetResponse {
  success: boolean;
  message?: string;
}

const deleteTempDataset = async ({ datasetID }: DeleteTempDatasetParams): Promise<DeleteTempDatasetResponse> => {
  const response = await axios<DeleteTempDatasetResponse>({
    url: `/sampling-planning/temp-datasets/eno1/${datasetID}`,
    method: 'DELETE',
    params: {
      comment: 'Y',
    },
  });
  return response.data;
};

interface UseDeleteTempDatasetOptions {
  onSuccess?: (data: DeleteTempDatasetResponse) => void;
  onError?: (error: any) => void;
}

export const useDeleteTempDataset = ({ onSuccess, onError }: UseDeleteTempDatasetOptions = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteTempDataset,
    onSuccess: (data) => {
      // Invalidate and refetch temp overview data
      queryClient.invalidateQueries({ queryKey: ['tempOverviewData'] });
      onSuccess?.(data);
    },
    onError: (error) => {
      console.error('Error deleting temp dataset:', error);
      onError?.(error);
    },
  });
};
